import {
  type GlobalCustomersSubscriptionItemDto,
  updateCustomerSubscriptionSubscriptionItem,
  type UpdateCustomerSubscriptionSubscriptionItemHeaders,
} from '@ori/global-api-client-react';

import type { HandlerSettings } from '../types';

type ReplaceSubscriptionHandlerSettings = Pick<HandlerSettings, 'client' | 'customerId' | 'tenant'>;

export type ReplaceSubscriptionParams = ReplaceSubscriptionHandlerSettings & {
  globalCustomersSubscriptionItemDto: GlobalCustomersSubscriptionItemDto;
  subscriptionId: number;
  subscriptionItemId: number;
  tenant: string;
};

export async function replaceSubscription({
  client,
  customerId,
  globalCustomersSubscriptionItemDto,
  subscriptionId,
  subscriptionItemId,
  tenant,
}: ReplaceSubscriptionParams) {
  // TODO -- Is this needed when there is the tenant prop of ApiProvider applied on some upper level?
  const headers: UpdateCustomerSubscriptionSubscriptionItemHeaders = {
    'x-tenant-context': tenant,
  };

  return updateCustomerSubscriptionSubscriptionItem(
    client,
    customerId,
    subscriptionId,
    subscriptionItemId,
    globalCustomersSubscriptionItemDto,
    headers,
  );
}
